$(document).ready(function () {
  $(".pw-select2-selectbox-deposit").select2({'placeholder': 'Select a date'});
  $(".pw-select2-selectbox").select2({'allowClear': false});

  $(".pw-select2-selectbox-address-remote").select2({
    ajax: {
      url: "/addresses/search",
      dataType: "json",
      data: function (params) {
        return {
          street_address: params.term,
          page: params.page,
        };
      },
      processResults: function (data, params) {
        params.page = params.page || 1;

        return {
          results: data,
          pagination: {
            more: params.page * 30 < data.length,
          },
        };
      },
    },
    minimumInputLength: 2,
    templateResult: formatAddress,
    dropdownCssClass: "pw-admin-normal-select2-dropdown",
    templateSelection: formatAddressSelection,
    allowClear: true,
  });

  function formatAddress(address) {
    if (address.street_address_unit === undefined) {
      return address.text;
    } else {
      return address.street_address_unit;
    }
  }

  function formatAddressSelection(address) {
    if (address.street_address_unit === undefined) {
      return address.text;
    } else {
      return address.street_address_unit;
    }
  }

  $(".pw-select2-selectbox-user-remote").select2({
    ajax: {
      url: "/admin/api/users/search",
      dataType: "json",
      data: function (params) {
        return {
          name: params.term,
          page: params.page,
        };
      },
      processResults: function (data, params) {
        params.page = params.page || 1;

        return {
          results: data,
          pagination: {
            more: params.page * 30 < data.length,
          },
        };
      },
    },
    minimumInputLength: 2,
    templateResult: formatUser,
    dropdownCssClass: "pw-admin-normal-select2-dropdown",
    templateSelection: formatUserSelection,
    allowClear: true,
  });

  function formatUser(user) {
    if (user.first_name === undefined) {
      return user.text;
    } else {
      return user.first_name + " " + user.last_name;
    }
  }

  function formatUserSelection(user) {
    if (user.first_name === undefined) {
      return user.text;
    } else {
      return user.first_name + " " + user.last_name;
    }
  }

  const communitySearchConfig = {
    ajax: {
      url: "/admin/api/communities/search",
      dataType: "json",
      data: function (params) {
        return {
          name: params.term,
          page: params.page,
        };
      },
      processResults: function (data, params) {
        params.page = params.page || 1;

        return {
          results: data,
          pagination: {
            more: params.page * 30 < data.length,
          },
        };
      },
    },
    minimumInputLength: 2,
    templateResult: formatCommunity,
    dropdownCssClass: "pw-admin-normal-select2-dropdown",
    templateSelection: formatCommunitySelection,
    allowClear: false,
  };

  $(".pw-select2-selectbox-community-remote").select2(communitySearchConfig);
  $('.pw-select2-selectbox-community-basic').select2();
  $(".pw-select2-selectbox-modal-community-remote").select2(
    Object.assign(communitySearchConfig, {
      dropdownParent: $(".popup-container"),
    })
  );

  function formatCommunity(community) {
    if (community.name === undefined) {
      return community.text;
    } else {
      return community.name;
    }
  }

  function formatCommunitySelection(community) {
    if (community.name === undefined) {
      return community.text;
    } else {
      return community.name;
    }
  }
});
